// extracted by mini-css-extract-plugin
module.exports = {"root":"tabs_bottomline_root__1nP-c"};